import MlService from "@/components/services/multilingual-service";

export default {
  props: {
    lang: {
      type: String,
      default: "EN"
    }
  },

  data: () => {
    return {
      mlService: new MlService()
    };
  },

  computed: {
    translationKeyInitial() {
      const id = this.activityInfo.id;
      return `${id}_${this.componentData.id}`;
    }
  },

  methods: {
    translateToActiveLang(key, defaultText, params = null) {
      let translatedText = this.mlService.i18nTranslate(key, this.lang);
      if (translatedText) {
        if (!!params && typeof params === "object") {
          Object.keys(params).forEach(paramKey => {
            if (translatedText.indexOf(`[${paramKey}]`) >= 0) {
              translatedText = translatedText.replace(`[${paramKey}]`, params[paramKey]);
            }
          });
        }
        return translatedText;
      }
      return defaultText;
    },

    setQuestionText() {
      if (!["SurveyInstruction", "Section"].includes(this.componentData.type)) {
        const translatedQuestionText = this.translateToActiveLang(`${this.translationKeyInitial}_formattedBody`, this.componentData.formattedBody);

        this.$set(this.componentData, "displayQuestionText", translatedQuestionText);
      }
    }
  },

  updated() {
    // Set the Translated text for the Question
    this.setQuestionText();
  }
};
